module.exports = __webpack_public_path__ + "img/theme-pic.fd16e434.png";